import React from 'react';
import BrandingFooter from '../common/BrandingFooter';
import TeamCell from '../common/TeamCell';

export default function TopScorers({
  showBranding = false,
  competitionLabel = 'Premier League',
  scorers = [],
}) {
  return (
    <div style={{ background: 'var(--sw-bg)', color: 'var(--sw-text)' }}>
      <div
        className="px-4 py-2 text-xs font-bold uppercase tracking-wide border-b"
        style={{ borderColor: 'var(--sw-border)', color: 'var(--sw-muted)' }}
      >
        {competitionLabel} — Top scorers
      </div>
      <div className="p-3">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[10px] uppercase" style={{ color: 'var(--sw-muted)' }}>
              <th className="p-2 w-8">#</th>
              <th className="p-2">Player</th>
              <th className="p-2">Team</th>
              <th className="p-2 text-right w-10">G</th>
              <th className="p-2 text-right w-10">A</th>
            </tr>
          </thead>
          <tbody>
            {scorers.map((r) => (
              <tr
                key={`${r.rank}-${r.player}-${r.team}`}
                style={{ borderTop: '1px solid var(--sw-border)' }}
              >
                <td className="p-2 font-mono text-xs">{r.rank}</td>
                <td className="p-2 font-medium">{r.player}</td>
                <td className="p-2 text-xs" style={{ color: 'var(--sw-muted)' }}>
                  <TeamCell row={r} />
                </td>
                <td className="p-2 text-right font-bold tabular-nums">{r.goals}</td>
                <td className="p-2 text-right tabular-nums">{r.assists}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!scorers.length && (
          <p className="text-center text-xs py-6" style={{ color: 'var(--sw-muted)' }}>
            No scorer data available.
          </p>
        )}
      </div>
      {showBranding && <BrandingFooter />}
    </div>
  );
}
